// extracted by mini-css-extract-plugin
module.exports = {"sectionNewsItem":"Item_sectionNewsItem_1S2IE","sectionRelated":"Item_sectionRelated_ONNmA"};